/**
 * Format a fraction (0...1) into a percent string with fixed decimals.
 * Uses EPSILON-safe rounding to avoid floating point precision issues.
 *
 * toPercent(0.42) === '42.000%'
 *
 * @param value - Fractional value between 0 and 1 (can be negative)
 * @param places - Number of decimal places to include (default: 3)
 * @returns Percent string with the requested precision
 */
export default function toPercent(value: number, places = 3) {
  try {
    const factor = Math.pow(10, places)
    const percentRaw = value * 100
    const percentRounded = Math.round((percentRaw + Number.EPSILON) * factor) / factor
    return `${percentRounded.toFixed(places)}%`
  } catch (error) {
    console.error('Error formatting number to percent', error)
    return `${Number.NaN.toFixed(places)}%`
  }
}
